









import { DashboardTile } from '@/utils/DashboardUtils';
import TileUtils, {
  TileAPIParams,
  TileNotificationsOptions,
} from '@/utils/TileUtils';
import NotificationUtils, {
  Notification,
  NotificationAssoc,
} from '@/utils/NotificationUtils';
import NotificationDisplay from '@/components/notification/NotificationDisplay.vue';
import mixins from 'vue-typed-mixins';
export default mixins().extend({
  components: {
    NotificationDisplay,
  },

  props: {
    tile: {
      type: Object as () => DashboardTile<TileNotificationsOptions>,
    },

    params: {
      type: Object as () => TileAPIParams,
    },
  },

  data(): {
    data?: NotificationAssoc[];
  } {
    return {
      data: undefined,
    };
  },

  mounted() {
    this.load();
  },

  methods: {
    async load() {
      try {
        this.data = undefined;
        this.$alert.hide('load');
        this.data = await TileUtils.getNotifications();
      } catch (error) {
        this.$alert.show('load', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
